import React, { useRef, useEffect } from 'react';
import { styled } from '@mui/system';

import { ConvertGIS } from '@datatox-bi/util';

const IFrameMapContainer = styled('iframe')({
    border: 0,
    minHeight: '29vw',
});

const MapChart = ({ datasetDruid, metaAtributos }) => {
    const iFrame = useRef(null);

    useEffect(() => {
        const { data, dataTypes } = ConvertGIS.makeDatasetGeo([...datasetDruid], metaAtributos);
        iFrame.current.contentWindow.SAIKU_PAYLOAD = {
            data,
            dataTypes,
        };
    }, []);

    return (
        <IFrameMapContainer
            allowFullScreen={true}
            ref={iFrame}
            referrerPolicy="unsafe-url"
            src={`/iframes/tmap/index.html?version=${global.gConfig?.modulo_versao}`}
            width="100%"
            height="100%"
        />
    );
};

export default MapChart;
